/**
 * Inplay types.
 *
 * @class InplayTypes
 * @name types
 * @memberof Mojito.Modules.Inplay
 */
export default class InplayTypes {}

/**
 * Inplay menu tabs enum.
 *
 * @readonly
 * @enum {string}
 * @memberof Mojito.Modules.Inplay.types
 */
InplayTypes.TABS = {
    /** All sports tab value, used to render events for all available sports. */
    ALL_SPORTS_CODE: 'all',
    /** Streaming events tab value. */
    STREAMING: 'streaming',
    /** Favorite events tab value. */
    FAVORITES: 'favorites',
    /** Sport tabs value used to identify the group of tabs for each separate sport in inplay menu. */
    SPORTS: 'sports',
};
